import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'memberAuditEdit',
  data: function data() {
    return {
      title: '',
      flag: false,
      form: {
        memberId: null,
        authorizationType: null,
        authorizationUserName: null,
        authorizationTypeList: [],
        pushAuditSts: 1,
        reviewAuditSts: 0,
        addMemberTimeSts: 0,
        authorizationAgencyUserName: null,
        authorizationMatchmakerUserName: null,
        memberSpecific: null,
        memberSpecificPublic: null,
        addTimeMemberPrice: null,
        matchmakerPermission: 0,
        // 默认改为不限制（1），这样下拉框会正确显示
        outerLinkSts: 0,
        // 加入外联权限 默认限制（0）
        matchmakerAmount: null,
        matchmakerViewSts: null,
        // 红娘查看权限状态：未选择时间时不提交修改（勿默认 0，避免清掉已有权限）
        matchmakerViewEndTime: null // 红娘查看权限结束时间
      },
      // 红娘查看权限结束时间选择限制：只能选择大于当天的日期
      matchmakerViewEndTimePickerOptions: {
        disabledDate: function disabledDate(time) {
          var todayEnd = new Date();
          todayEnd.setHours(23, 59, 59, 999);
          return time.getTime() <= todayEnd.getTime();
        }
      },
      rules: {
        authorizationType: [{
          required: true,
          message: '请选择授权类型',
          trigger: 'blur'
        }],
        authorizationUserName: [{
          required: true,
          message: '请输入要关联的后台管理账号',
          trigger: 'blur'
        }],
        authorizationTypeList: [{
          required: true,
          message: '请选择授权类型',
          trigger: 'blur'
        }],
        memberSpecific: [{
          required: true,
          message: '请选择会员专享',
          trigger: 'blur'
        }],
        memberSpecificPublic: [{
          required: true,
          message: '请选择红娘共享',
          trigger: 'blur'
        }],
        pushAuditSts: [{
          required: true,
          message: '请选择推送权限',
          trigger: 'blur'
        }],
        // 屏蔽【开通红娘权限】后不再需要该校验
        //        matchmakerPermission: [
        //          { required: true, message: '请选择开通红娘权限', trigger: 'blur' }
        //        ],
        outerLinkSts: [{
          required: true,
          message: '请选择加入外联权限',
          trigger: 'blur'
        }],
        matchmakerViewEndTime: [{
          validator: function validator(rule, value, callback) {
            if (!value) {
              return callback();
            }
            // 结束时间固定为所选日期的 23:59:59，须大于当天
            if (new Date(String(value).replace(/-/g, '/') + ' 23:59:59').getTime() <= Date.now()) {
              return callback(new Error('红娘共享权限结束时间必须大于当天'));
            }
            callback();
          },
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    change: function change(val) {
      for (var i = 0; i < val.length; i++) {
        var sss = val[i];
        if (sss === 2 || sss === 3 || sss === 6) {
          this.flag = true;
        } else {
          this.flag = false;
          this.form.authorizationUserName = null;
        }
      }
      if (val.length === 0) {
        this.flag = false;
        this.form.authorizationUserName = null;
      }
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.authorizationTypeList = null;
      this.form.authorizationType = data.authorizationType;
      this.form.authorizationTypeList = JSON.parse(data.authorizationTypeSz);
      this.form.authorizationTypeList = this.form.authorizationTypeList.filter(function (item) {
        return item !== 4 && item !== 5;
      });
      this.change(this.form.authorizationTypeList);
      this.form.memberId = data.memberId;
      this.form.authorizationUserName = data.authorizationUserName;
      this.form.reviewAuditSts = data.reviewAuditSts;
      this.form.pushAuditSts = data.pushAuditSts;
      this.form.addMemberTimeSts = data.addMemberTimeSts;
      this.form.authorizationMatchmakerUserName = data.authorizationMatchmakerUserName;
      this.form.authorizationAgencyUserName = data.authorizationAgencyUserName;
      this.form.memberSpecific = data.memberSpecific;
      this.form.memberSpecificPublic = data.memberSpecificPublic;
      this.form.addTimeMemberPrice = data.addTimeMemberPrice;
      // 开通红娘权限回显处理：如果后端有值则使用，否则默认为 0（限制）
      if (data.matchmakerPermission !== undefined && data.matchmakerPermission !== null && data.matchmakerPermission !== '') {
        this.form.matchmakerPermission = parseInt(data.matchmakerPermission);
      } else {
        this.form.matchmakerPermission = 0;
      }
      // 加入外联权限回显处理：如果后端有值则使用，否则默认为 0（限制）
      if (data.outerLinkSts !== undefined && data.outerLinkSts !== null && data.outerLinkSts !== '') {
        this.form.outerLinkSts = parseInt(data.outerLinkSts);
      } else {
        this.form.outerLinkSts = 0;
      }
      this.form.matchmakerAmount = data.matchmakerAmount;
      // 红娘查看权限结束时间回显：只取日期部分（结束时间固定为所选日期 23:59:59）
      this.form.matchmakerViewEndTime = data.matchmakerViewEndTime ? String(data.matchmakerViewEndTime).substring(0, 10) : null;
      if (this.form.authorizationTypeList.length === 0) {
        this.form.pushAuditSts = 1;
      }
    },
    updateApi: function updateApi() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.updateMatchmakerReview(_this.form);
            case 1:
              _this.$emit('initTableData');
              _this.$message.success('操作成功');
              _this.handleClose();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    saveApi: function saveApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.SAVE_GIFT(_this2.form);
            case 1:
              _this2.$emit('initTableData');
              _this2.$message.success('操作成功');
              _this2.handleClose();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    save: function save() {
      var _this3 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          // 红娘查看权限：选择日期则默认把权限状态置为打开(1)，结束时间固定为该日期 23:59:59；未选择则不提交、不改动原有数据
          if (_this3.form.matchmakerViewEndTime) {
            _this3.form.matchmakerViewSts = 1;
            _this3.form.matchmakerViewEndTime = String(_this3.form.matchmakerViewEndTime).substring(0, 10) + ' 23:59:59';
          } else {
            _this3.form.matchmakerViewSts = null;
            _this3.form.matchmakerViewEndTime = null;
          }
          if (_this3.form.memberId != null) {
            _this3.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this3.updateApi();
            }).catch(function () {
              _this3.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this3.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};